module.exports = __webpack_public_path__ + "static/media/mouton_02_full.a38bf25b.jpg";